export const MIN_SEARCH_TEXT_LENGTH = 2
export const NUM_SKIN_TONES = 6
